import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface ProductSearchProps {
  className?: string;
  placeholder?: string;
  inlineButton?: boolean;
  buttonText?: string;
  buttonClassName?: string;
}

const ProductSearch: React.FC<ProductSearchProps> = ({
  className = "",
  placeholder = "Search content...",
  inlineButton = true,
  buttonText = "Search",
  buttonClassName = "",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(
        `/content-search-results?q=${encodeURIComponent(searchTerm.trim())}`
      );
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex ${
        inlineButton ? "flex-row" : "flex-col gap-2"
      } ${className}`}
    >
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={placeholder}
        className="flex-grow px-4 py-2 rounded-l-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      <button
        type="submit"
        className={`px-6 py-2 ${
          inlineButton ? "rounded-r-md" : "rounded-md"
        } text-white font-medium ${
          buttonClassName || "bg-blue-600 hover:bg-blue-700"
        }`}
      >
        {buttonText}
      </button>
    </form>
  );
};

export default ProductSearch;
